import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache) {
  return _openBlock(), _createBlock("img", {
    class: "icon",
    src: _ctx.imgSrc(),
    alt: _ctx.imgAlt()
  }, null, 8, ["src", "alt"]);
}